import BaseModel from './BaseModel'

export default class InventoryLoanerEvent extends BaseModel {
  // ... InventoryLoanerEvent-specific methods or overrides ...
}
